const styles = {
  sectionTight: { marginBottom: 0, minWidth: 0 },
  twoCol: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 20, marginBottom: 40 },
  statGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))", gap: 14 },
  statTile: { background: "var(--bg-surface)", border: "2px solid var(--ink)", borderRadius: 16, boxShadow: "3px 3px 0 0 var(--ink)", padding: "14px 12px", display: "flex", flexDirection: "column", alignItems: "center", gap: 2 },
  statIcon: { fontSize: 20 },
  statValue: { fontFamily: "'Itim', cursive", fontSize: 30, fontWeight: 700, color: "var(--ink)", lineHeight: 1.1 },
  statLabel: { fontFamily: "'Itim', cursive", fontSize: 12.5, color: "var(--ink-soft)", textAlign: "center" },
  listCard: { background: "var(--bg-surface)", border: "2px solid var(--ink)", borderRadius: 18, boxShadow: "4px 4px 0 0 var(--ink)", padding: 8, display: "flex", flexDirection: "column", gap: 2 },
  listRow: { display: "flex", alignItems: "center", gap: 10, width: "100%", background: "transparent", border: "none", borderRadius: 10, padding: "9px 10px", cursor: "pointer", textAlign: "left", fontFamily: "'Itim', cursive" },
  listMain: { display: "flex", flexDirection: "column", minWidth: 0, flex: 1 },
  listTitle: { fontSize: 14.5, color: "var(--ink)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  listSub: { fontSize: 12, color: "var(--ink-faint)" },
  duePill: { fontSize: 12, fontWeight: 700, color: "var(--ink)", background: "color-mix(in srgb, var(--ink) 8%, var(--bg-surface))", borderRadius: 999, padding: "2px 10px", flexShrink: 0 },
  duePillLate: { color: "#C23B33", background: "color-mix(in srgb, #E0473E 18%, var(--bg-surface))" },
  groupDot: { width: 30, height: 30, borderRadius: "50%", background: "var(--accent-color)", color: "#FFFDF8", border: "2px solid var(--ink)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 13, flexShrink: 0 },
  roleTag: { fontSize: 11.5, fontWeight: 700, color: "var(--accent-color)", background: "color-mix(in srgb, var(--accent-color) 14%, var(--bg-surface))", borderRadius: 999, padding: "2px 10px", flexShrink: 0 },
  emptyMini: { fontFamily: "'Itim', cursive", fontSize: 13.5, color: "var(--ink-faint)", margin: 0, padding: "12px 10px" },

  modalOverlay: { position: "fixed", inset: 0, zIndex: 100, background: "rgba(20,16,10,0.5)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16, boxSizing: "border-box" },
  modal: { background: "var(--bg-page)", border: "2.5px solid var(--ink)", borderRadius: 20, boxShadow: "6px 6px 0 0 var(--ink)", width: "100%", maxWidth: 640, maxHeight: "90vh", display: "flex", flexDirection: "column", overflow: "hidden" },
  modalHead: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 22px 10px" },
  modalTitle: { fontFamily: "'Itim', cursive", fontSize: 22, fontWeight: 700, color: "var(--ink)", margin: 0 },
  modalClose: { width: 32, height: 32, borderRadius: "50%", border: "2px solid var(--ink)", background: "var(--bg-surface)", color: "var(--ink)", fontSize: 18, lineHeight: 1, cursor: "pointer" },
  tabRow: { display: "flex", gap: 6, padding: "0 22px 12px", flexWrap: "wrap", borderBottom: "1.5px dashed var(--ink-faint)" },
  tabBtn: { fontFamily: "'Itim', cursive", fontSize: 13.5, color: "var(--ink-soft)", background: "transparent", borderWidth: 2, borderStyle: "solid", borderColor: "transparent", borderRadius: 999, padding: "6px 14px", cursor: "pointer" },
  tabBtnOn: { color: "var(--ink)", fontWeight: 700, background: "var(--bg-surface)", borderColor: "var(--ink)" },
  modalBody: { padding: "18px 22px 22px", overflowY: "auto" },

  layout: { display: "grid", gridTemplateColumns: "280px minmax(0, 1fr)", gap: 36, alignItems: "start" },
  side: { position: "sticky", top: 84, display: "flex", flexDirection: "column", background: "var(--bg-surface)", border: "2.5px solid var(--ink)", borderRadius: 22, boxShadow: "5px 5px 0 0 var(--ink)", overflow: "hidden" },
  sideCover: { position: "relative", height: 92, background: "color-mix(in srgb, var(--accent-color) 24%, var(--bg-surface))", borderBottom: "2.5px solid var(--ink)" },
  sideBody: { display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: 4, padding: "0 20px 20px" },
  sideItem: { display: "block", padding: "7px 12px", borderRadius: 12, background: "color-mix(in srgb, var(--accent-color) 8%, var(--bg-page))", border: "1.5px dashed color-mix(in srgb, var(--ink) 28%, transparent)", textAlign: "left" },
  mainCol: { minWidth: 0 },
  avatarWrapBig: { position: "relative", width: 144, height: 144, marginTop: -72, marginBottom: 10, alignSelf: "center" },
  avatarImgBig: { width: 144, height: 144, borderRadius: "50%", border: "3px solid var(--ink)", objectFit: "cover", display: "block", background: "var(--bg-page)", boxShadow: "4px 4px 0 0 var(--ink)" },
  avatarFallbackBig: { width: 144, height: 144, borderRadius: "50%", border: "3px solid var(--ink)", background: "var(--accent-color)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 58, fontWeight: 700, color: "#FFFDF8", boxShadow: "4px 4px 0 0 var(--ink)" },
  sideName: { fontFamily: "'Itim', cursive", fontSize: 26, fontWeight: 700, color: "var(--ink)", margin: "4px 0 0", lineHeight: 1.2, wordBreak: "break-word" },
  sideUsername: { fontFamily: "'Itim', cursive", fontSize: 18, color: "var(--ink-soft)", margin: "0 0 8px" },
  sideBio: { fontFamily: "'Itim', cursive", fontSize: 15, color: "var(--ink)", margin: "4px 0 12px", lineHeight: 1.5, whiteSpace: "pre-wrap", wordBreak: "break-word" },
  editProfileBtn: { fontSize: 15, fontWeight: 700, color: "var(--ink)", background: "color-mix(in srgb, var(--accent-color) 18%, var(--bg-surface))", padding: "8px 14px", width: "100%", margin: "8px 0 14px" },
  sideList: { listStyle: "none", margin: 0, padding: 0, width: "100%", display: "flex", flexDirection: "column", gap: 7, fontFamily: "'Itim', cursive", fontSize: 14, color: "var(--ink-soft)", wordBreak: "break-word" },

  section: {
    marginBottom: 40,
  },
  sectionTitle: {
    fontFamily: "'Itim', cursive",
    fontWeight: 700,
    fontSize: "clamp(20px, 2.4vw, 24px)",
    color: "var(--ink)",
    margin: "0 0 16px",
  },
  card: {
    background: "var(--bg-surface)",
    border: "2px solid var(--ink)",
    borderRadius: 18,
    boxShadow: "4px 4px 0 0 var(--ink)",
    padding: "28px 26px",
    boxSizing: "border-box",
  },

  /* --- avatar block --- */
  avatarRow: {
    display: "flex",
    alignItems: "center",
    gap: 22,
    flexWrap: "wrap",
  },
  avatarWrap: {
    position: "relative",
    width: 100,
    height: 100,
    flexShrink: 0,
  },
  avatarImg: {
    width: 100,
    height: 100,
    borderRadius: "50%",
    border: "2.5px solid var(--ink)",
    objectFit: "cover",
    display: "block",
    background: "var(--bg-page)",
  },
  avatarFallback: {
    width: 100,
    height: 100,
    borderRadius: "50%",
    border: "2.5px solid var(--ink)",
    background: "var(--accent-color)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 38,
    fontWeight: 700,
    color: "#FFFDF8",
  },
  avatarEditBtn: {
    position: "absolute",
    bottom: -2,
    right: -2,
    width: 34,
    height: 34,
    borderRadius: "50%",
    background: "var(--bg-surface)",
    border: "2px solid var(--ink)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 15,
    cursor: "pointer",
  },
  avatarMeta: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  avatarName: {
    fontFamily: "'Itim', cursive",
    fontSize: 20,
    fontWeight: 700,
    color: "var(--ink)",
    margin: 0,
  },
  avatarSub: {
    fontFamily: "'Itim', cursive",
    fontSize: 14,
    color: "var(--ink-soft)",
    margin: 0,
  },
  avatarHint: {
    fontSize: 12.5,
    color: "var(--ink-faint)",
    margin: "4px 0 0",
  },

  /* --- edit form --- */
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 18,
  },
  label: {
    fontFamily: "'Itim', cursive",
    fontSize: 15,
    color: "var(--ink)",
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  labelReadonly: {
    fontFamily: "'Itim', cursive",
    fontSize: 15,
    color: "var(--ink-faint)",
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  readonlyValue: {
    fontFamily: "'Itim', cursive",
    fontSize: 15,
    color: "var(--ink-soft)",
    background: "var(--bg-page)",
    border: "2px solid #D8D0C0",
    borderRadius: 10,
    padding: "10px 14px",
  },
  orgTypeRow: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
  },
  orgTypeBtn: {
    fontFamily: "'Itim', cursive",
    fontSize: 14,
    color: "var(--ink-soft)",
    background: "var(--bg-surface)",
    border: "2px solid var(--ink)",
    borderRadius: 999,
    padding: "9px 18px",
    cursor: "pointer",
  },
  orgTypeBtnActive: {
    background: "var(--accent-color)",
    color: "#FFFDF8",
    fontWeight: 700,
  },
  errorText: {
    fontSize: 12.5,
    color: "#E0473E",
  },
  successText: {
    fontSize: 13,
    color: "#2E8B4F",
    margin: 0,
  },
  saveRow: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    marginTop: 4,
  },
  saveBtn: {
    fontFamily: "'Itim', cursive",
    fontSize: 15,
    fontWeight: 700,
    color: "#FFFDF8",
    background: "var(--accent-color)",
    padding: "11px 26px",
    border: "2px solid var(--ink)",
  },

  bioTextarea: {
    fontFamily: "'Itim', cursive",
    fontSize: 15,
    resize: "vertical",
    minHeight: 72,
  },
  bioCounter: {
    fontSize: 12,
    color: "var(--ink-faint)",
    alignSelf: "flex-end",
  },

  /* --- privacy toggles --- */
  privacyRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 14,
    padding: "12px 0",
    borderBottom: "1.5px dashed #E7E2D6",
  },
  privacyRowLast: {
    borderBottom: "none",
  },
  privacyMeta: {
    display: "flex",
    flexDirection: "column",
    gap: 3,
  },
  privacyLabel: {
    fontFamily: "'Itim', cursive",
    fontSize: 15,
    fontWeight: 700,
    color: "var(--ink)",
  },
  privacyDesc: {
    fontSize: 12.5,
    color: "var(--ink-faint)",
  },
  toggle: {
    width: 40,
    height: 22,
    borderRadius: 999,
    border: "2px solid #C9C0AE",
    background: "#E7E2D6",
    position: "relative",
    cursor: "pointer",
    padding: 0,
    flexShrink: 0,
  },
  toggleOn: {
    background: "var(--accent-color)",
    border: "2px solid var(--accent-color)",
  },
  toggleKnob: {
    position: "absolute",
    top: 1,
    left: 1,
    width: 16,
    height: 16,
    borderRadius: "50%",
    background: "var(--bg-surface)",
    transition: "transform 120ms ease",
  },
  toggleKnobOn: {
    transform: "translateX(18px)",
  },
  privacyNote: {
    fontSize: 13,
    color: "var(--ink-soft)",
    margin: "14px 0 0",
  },

  /* --- theme picker --- */
  swatchGrid: {
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 16,
  },
  swatchBtn: {
    width: 42,
    height: 42,
    borderRadius: "50%",
    border: "2.5px solid var(--ink)",
    cursor: "pointer",
    padding: 0,
    position: "relative",
  },
  swatchCheck: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FFFDF8",
    fontSize: 16,
    fontWeight: 700,
    textShadow: "0 1px 2px rgba(0,0,0,0.4)",
  },
  customColorRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
  },
  colorSwatchInput: {
    width: 44,
    height: 44,
    padding: 0,
    border: "2.5px solid var(--ink)",
    borderRadius: 10,
    cursor: "pointer",
    background: "none",
  },
  hexInput: {
    width: 120,
  },
  previewNote: {
    fontSize: 13,
    color: "var(--ink-soft)",
    margin: "14px 0 0",
  },

  /* --- danger zone --- */
  dangerCard: {
    background: "#FFF6F5",
    border: "2px solid #E0473E",
    borderRadius: 18,
    padding: "26px 24px",
    boxSizing: "border-box",
  },
  dangerTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#B8302A",
    margin: "0 0 8px",
  },
  dangerDesc: {
    fontSize: 14,
    color: "#7A4A46",
    margin: "0 0 18px",
    lineHeight: 1.6,
  },
  deleteBtn: {
    fontFamily: "'Itim', cursive",
    fontSize: 15,
    fontWeight: 700,
    color: "#FFFDF8",
    background: "#E0473E",
    padding: "11px 22px",
    border: "2px solid var(--ink)",
  },
  confirmBox: {
    background: "var(--bg-surface)",
    border: "2px dashed #E0473E",
    borderRadius: 14,
    padding: "20px 20px",
    display: "flex",
    flexDirection: "column",
    gap: 14,
  },
  confirmText: {
    fontSize: 14.5,
    color: "var(--ink)",
    margin: 0,
    lineHeight: 1.6,
  },
  confirmActions: {
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
  },
  cancelBtn: {
    fontFamily: "'Itim', cursive",
    fontSize: 14,
    color: "var(--ink)",
    background: "var(--bg-surface)",
    padding: "10px 20px",
    border: "2px solid var(--ink)",
  },
  confirmDeleteBtn: {
    fontFamily: "'Itim', cursive",
    fontSize: 14,
    fontWeight: 700,
    color: "#FFFDF8",
    background: "#E0473E",
    padding: "10px 20px",
    border: "2px solid var(--ink)",
  },
};

export default styles;
